/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { fetchSendMail } from "store/reducers/contact-us";

// icons
import SendIcon from "../../../assets/icons/send.svg";

import { Form, Input, Button, Row, Col } from "antd";

const ContactUs = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loading, isSent } = useSelector((state) => state.contactUs);

  useEffect(() => {
    console.log("form: ", form, isSent);
    if (isSent) {
      form.resetFields();
      console.log("form: ", form);
      form.resetFields();
    }
  }, [isSent]);

  const onFinish = (values) => {
    console.log("handle finish: ", values);
    const data = {
      from: values.email,
      name: values.name,
      // "to": '',
      subject: `Contact Us - ${values.name}`,
      message: values.message,
    };

    dispatch(fetchSendMail(data));
  };

  return (
    <div className="contactUs" ref={props.contactRef}>
      <div className="content">
        <h2>Contact us!</h2>
        <h6>
          We look forward to answering your questions and giving you updates on
          the Precog ecosystem.{" "}
        </h6>

        {isSent && (
          <div className="customAlertError">
            Message has been sent successfully. You'll heard from us soon!
          </div>
        )}

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
        >
          <Row gutter={44}>
            <Col md={12} xs={24}>
              <Form.Item
                label="Your name"
                name="name"
                rules={[{ required: true, message: "Please input your name" }]}
              >
                <Input placeholder="Enter your name" />
              </Form.Item>
            </Col>
            <Col md={12} xs={24}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email" },
                  { type: "email", message: "Please input correct your email" },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                label="Message"
                name="message"
                rules={[
                  {
                    required: true,
                    message: "Please input message",
                  },
                ]}
              >
                <Input.TextArea rows={6} placeholder="Type your message" />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <div className="actions">
                <Button
                  icon={<img alt="" src={SendIcon} />}
                  htmlType="submit"
                  loading={loading}
                >
                  Send message
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ContactUs;
